// @flow
import { call, put, takeLatest, select, fork } from 'redux-saga/effects';
import getModerationContent from 'api/content/getModerationContent';
import {
  requestContent,
  receiveContent,
  receivePreviousUgcIdUpdate,
} from './moderateActions';
import {
  requestObservationsUpdate,
  commitObservationsUpdate,
} from 'ducks/coreDataActions';
import { type ActionType } from 'redux-actions';
import { addItemTask } from 'ducks/coreDataSaga';
import storage from './moderateStorage';

export function* requestModerateContent(
  action: ActionType<typeof requestContent>
): Generator<*, *, *> {
  const { token, observationsMap } = action.payload;
  try {
    const data: ContentBlob = yield call(getModerationContent, token);
    const ugc_id = yield call(addItemTask, {
      data,
      observationsMap,
      clientId: 1,
    });

    yield put.resolve(receiveContent({ ugc_id }));
  } catch (error) {
    yield put(receiveContent(error));
  }
}

function* saveCompletedCount() {
  const count = yield select(state => state.moderate.getCompletedCount());

  yield call(storage.saveTodayCount, count);
}

function* postThenSave(action) {
  try {
    yield fork(saveCompletedCount);
  } catch (err) {}
}

function* triggerUpdatePreviousUgcId(action) {
  const ugcId = action.payload.ugcId;
  try {
    yield put.resolve(receivePreviousUgcIdUpdate(ugcId));
  } catch (err) {}
}

export default function* moderateSaga(): Generator<*, *, *> {
  yield takeLatest(requestContent, requestModerateContent);
  yield takeLatest(requestObservationsUpdate, postThenSave);
  yield takeLatest(commitObservationsUpdate, triggerUpdatePreviousUgcId);
}



// WEBPACK FOOTER //
// ./src/pages/moderation/moderate/moderateSaga.js